module.exports = __webpack_public_path__ + "img/无订单.2bda6bb2.png";